import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ChevronDownCircleSVG = function ChevronDownCircleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 30A14 14 0 102 16c0 10.4 9 14 14 14zM9.3 13.3a1 1 0 011.4 0l5.3 5.3 5.3-5.3a1 1 0 011.4 0 1 1 0 010 1.4l-6 6a1 1 0 01-1.4 0l-6-6a1 1 0 010-1.4z"
  }));
};
ChevronDownCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ChevronDownCircleSVG);